import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Renderer2, inject } from '@angular/core';
import type { FlightStatusFormData } from '@com-delta-idp/mnx-capability-flight-status-ui';
import { FlightStatusComponent } from '@com-delta-idp/mnx-capability-flight-status-ui';
import {
  AirportDropdownComponent,
  AnalyticsDataPopulateService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { DestinationType } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { MessageBanner, Search } from '@com-delta-omnichannel/mach-core-js';
import { FLIGHT_STATUS_SMART_CONSTANTS } from '../data-access/models/constants/flight-status.constants';
import { FlightStatusContainerBaseComponent } from './flight-status-container-base.component';

@Component({
  selector: 'idp-flight-status-container',
  standalone: true,
  imports: [CommonModule, FlightStatusComponent, AirportDropdownComponent],
  templateUrl: './flight-status-container.component.html',
  styleUrls: ['./flight-status-container.component.scss']
})
export class FlightStatusContainerComponent
  extends FlightStatusContainerBaseComponent
  implements OnInit
{
  @Input() isSelected = false;
  render2 = inject(Renderer2);
  analyticsService = inject(AnalyticsDataPopulateService);

  ngOnInit(): void {
    this.flightStatusFacade.init(this.onInitComplete);
    this.initializeAirportModalContent();
    this.flightStatusFacade.onDataReady = () => this.handleDataReady();
  }

  onInitComplete = (success: boolean): void => {
    if (!success) {
      setTimeout(() => {
        this.showAlert = true;
        this.messageBanner = new MessageBanner(
          this.flightStatusFacade.adapter.setErrorBanner()
        );
      }, 100);
    }
  };

  retrieveFlightStatus(event: FlightStatusFormData): void {
    this.flightStatusFacade.loadFlightStatus(event);
  }

  handleAnalytics(element: HTMLElement): void {
    this.analyticsService.populateAnalyticsData(element);
  }

  openModal(
    event: { isOpen: boolean; triggerType?: 'origin' | 'destination' } | boolean
  ): void {
    const isOpen = typeof event === 'boolean' ? event : event.isOpen;
    const triggerType =
      typeof event === 'object' ? event.triggerType : undefined;

    this.openModalEvent = isOpen;
    if (isOpen) {
      this.setupModalForOpening(triggerType);
    } else {
      this.searchInstance = null as unknown as Search;
    }
  }

  private setupModalForOpening(triggerType?: 'origin' | 'destination'): void {
    this.lastApiCall = '';
    this.flightStatusFacade.predictiveCities = [];
    this.isPrefilledValue = true;

    this.destinationType = triggerType === 'origin' ? 'From' : 'To';

    this.airportModalContent.airportList.title =
      this.destinationType === 'From'
        ? FLIGHT_STATUS_SMART_CONSTANTS.LABELS.ORIGIN
        : FLIGHT_STATUS_SMART_CONSTANTS.LABELS.DESTINATION;

    this.airportModalContent.airportList.items =
      this.destinationType === 'From'
        ? this.originAirportSearchResults
        : this.destinationAirportSearchResults;
  }

  onDestinationTypeSelected(destination: DestinationType): void {
    this.destinationType = destination;
  }
}
